import React, { useState, useEffect } from "react";
import "./ApproveCandidates.css";
import toast from "react-hot-toast";
import axiosInstance from "../axios/axiosInstance";
import { X } from "lucide-react";

const ScheduleInterviewDetailsModal = ({
  isOpen,
  onClose,
  candidate,
  onSubmit,
  isUpdate = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);

  // Fetch previous data when isUpdate is true
  useEffect(() => {
    const fetchInterviewData = async () => {
      if (isOpen && isUpdate && candidate?.user_id) {
        setLoading(true);
        try {
          const response = await axiosInstance.get(
            `/api/admin/candidates/candidate-eq-schedule/${candidate.user_id}`,
          );

          if (response.data) {
            // Set toggle based on whether interview data exists
            setIsScheduled(true);
          }
        } catch (error) {
          console.error("Error fetching previous interview details:", error);
          toast.error("Failed to load previous interview details");
        } finally {
          setLoading(false);
        }
      } else if (isOpen && !isUpdate) {
        // Reset for new entry
        setIsScheduled(false);
      }
    };

    fetchInterviewData();
  }, [isOpen, isUpdate, candidate?.user_id]);

  const handleFormSubmit = async (e) => {
    setSubmitLoading(true);
    e.preventDefault();
    try {
      if (!isScheduled) {
        handleClose();
        return;
      }
      await onSubmit({ is_scheduled: isScheduled });
      onClose();
      setSubmitLoading(false);
    } catch (error) {
      console.error("Error submitting interview status:", error);
      setSubmitLoading(false);
    }
  };

  const handleClose = () => {
    setIsScheduled(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <div className="dialog-header">
          <h2>
            {isUpdate ? "Update Interview Status" : "Set Interview Status"}
          </h2>
          <button className="modal-close" onClick={handleClose}>
            <X size={24} />
          </button>
        </div>

        <div className="dialog-body">
          {candidate && (
            <div className="candidate-info-section">
              <p>
                <strong>Candidate:</strong> {candidate.first_name}{" "}
                {candidate.last_name}
              </p>
              <p>
                <strong>Email:</strong> {candidate.email}
              </p>
            </div>
          )}

          {loading ? (
            <div
              className="loading-spinner"
              style={{ textAlign: "center", padding: "2rem" }}
            >
              Loading interview status...
            </div>
          ) : (
            <form onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    cursor: "pointer",
                    fontSize: "1rem",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isScheduled}
                    onChange={(e) => setIsScheduled(e.target.checked)}
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                  />
                  <span>Interview Scheduled</span>
                </label>
              </div>

              <div className="dialog-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoading}
                >
                  {submitLoading
                    ? "Setting Status..."
                    : isUpdate
                      ? "Update Status"
                      : "Set Status"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScheduleInterviewDetailsModal;
